import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import RefreshIcon from '@mui/icons-material/Refresh';
import Button from '@material-ui/core/Button';
import { INTEGRATIONS_DEVICE, INTEGRATIONS_SERVER } from '../../../constants/IntegrationsConst';
import { useSelector } from 'react-redux';
import { selectedHotelSelector } from '../../property/propertySlice';
import { useHistory } from 'react-router-dom';
import CustomIntegrationsCard from '../../../shared/custom-integrations-card/CustomIntegrationsCard';
import './Integrations.scss';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const Integrations = () => {
  const [activeTab, setActiveTab] = useState(INTEGRATIONS_SERVER);
  const classes = useStyles();

  return (
    <div className='container mt-4'>
      <div className='row d-flex'>
        <div className='col-md-6'>
          <span className='page-title'>Integrations</span>
        </div>
        <div className='col-md-6 d-flex justify-content-end'>
          <Button variant='outlined' size='large' color='secondary' endIcon={<RefreshIcon />}>
            Refresh
          </Button>
        </div>
      </div>
      <div className='row d-flex mt-4 accommodation-list'>
        <div className='d-flex flex-wrap'>
          <Button
            size='large'
            variant={activeTab === INTEGRATIONS_SERVER ? 'outlined' : 'text'}
            className={activeTab === INTEGRATIONS_SERVER ? classes.activeButton : classes.button}
            onClick={() => setActiveTab(INTEGRATIONS_SERVER)}
          >
            Server
          </Button>
          <Button
            size='large'
            variant={activeTab === INTEGRATIONS_DEVICE ? 'outlined' : 'text'}
            className={activeTab === INTEGRATIONS_DEVICE ? classes.activeButton : classes.button}
            onClick={() => setActiveTab(INTEGRATIONS_DEVICE)}
          >
            Device
          </Button>
        </div>
      </div>
      <div className='row mx-2 d-flex mt-4 cards-container'>
        <div className='card shadow intergrations-wrapper'>
          {activeTab === 'SERVER' && (
            <div className='ms-4 mt-2'>
              <h4 className='mt-4'>06 Integrations</h4>
              <div className=' mt-4 ms-1 me-5 row row-cols-3'>
                <CustomIntegrationsCard
                  name={'Opera'}
                  icon={'/assets/img/integrations/opera.png'}
                  subtext={'Room Reservation'}
                />
                <CustomIntegrationsCard
                  name={'Symphony'}
                  icon={'/assets/img/integrations/micros.png'}
                  subtext={'In-Room Dining'}
                />
                <CustomIntegrationsCard
                  name={'SpaSoft'}
                  icon={'/assets/img/integrations/spasoft.png'}
                  subtext={'Spa Reservation'}
                />
              </div>
              <div className=' mt-4 ms-1 me-5 row row-cols-3'>
                <CustomIntegrationsCard
                  name={'VDA'}
                  icon={'/assets/img/integrations/vda.png'}
                  subtext={'Lights / Scenes / Curtains'}
                />
                <CustomIntegrationsCard
                  name={'Honeywell'}
                  icon={'/assets/img/integrations/honeyWell.png'}
                  subtext={'Thermostat'}
                />
                <CustomIntegrationsCard
                  name={'Assa Abloy'}
                  icon={'/assets/img/integrations/assaAbloy.png'}
                  subtext={'Digital Door Lock'}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Integrations;
